export const AUTH = 'authorization';
